import { render, staticRenderFns } from "./ImprimantesHpPagewide.vue?vue&type=template&id=32712739&scoped=true"
import script from "./ImprimantesHpPagewide.vue?vue&type=script&lang=js"
export * from "./ImprimantesHpPagewide.vue?vue&type=script&lang=js"
import style0 from "./ImprimantesHpPagewide.vue?vue&type=style&index=0&id=32712739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32712739",
  null
  
)

export default component.exports